import { CSSWithMultiValues, SystemCSSProperties, SystemStyleObject, chakra } from '@chakra-ui/react'

import { Theme } from 'src/themes/types'

export const Panel = chakra('div', {
    baseStyle: ({ theme }) => ({
        padding: '8px 0',
        display: 'flex',
        flexDirection: 'column',
        width: '240px',
        backgroundColor: theme.palette.languageSelect.desktopBgColor,
        borderRadius: '6px',

        [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
            padding: 0,
            width: '100%',
        },
    }),
})

export const TextContent = chakra('span', {
    baseStyle: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
        display: 'block',
    },
})

export const HeightLimiter = chakra('div', {
    baseStyle: {
        maxHeight: '300px',
        overflowY: 'auto',
        scrollbarWidth: 'thin',
    },
})

export const LanguageOptionList = chakra('ul', {
    baseStyle: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        width: '100%',
    },
})

export const LanguageOptionItem = chakra('li', {})

type BaseStyleType = (props: { theme: Theme }) => SystemStyleObject
const baseStyle: BaseStyleType = ({ theme }) => ({
    color: theme.palette.languageSelect.desktopTextColor,
    fontSize: '14px',
    lineHeight: '21px',
    padding: '8px 40px 8px 16px',
    width: '100%',
    textAlign: 'left',
    position: 'relative',

    svg: {
        position: 'absolute',
        top: '11px',
        right: '16px',
        strokeWidth: '2px',
    },

    [`@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)`]: {
        padding: '16px 40px 16px 16px',
        fontSize: '16px',
        lineHeight: '24px',
        color: theme.palette.languageSelect.mobileTextColor,

        svg: {
            top: 'unset',
            bottom: '20px',
        },
    },
})

export const DefaultLanguage = chakra('span', {
    baseStyle: ({ theme }) => {
        const styles = baseStyle({ theme })
        const mediaTablet = `@container (max-width: ${theme.breakPoints.tabletMaxWidth}px)` as keyof SystemCSSProperties

        return {
            ...styles,
            paddingBottom: '16px',
            borderBottom: `1px solid ${theme.palette.languageSelect.separatorColor}`,
            [mediaTablet]: {
                ...(styles[mediaTablet] as CSSWithMultiValues),
                paddingTop: '24px',
            },
        }
    },
})

export const LanguageButton = chakra('button', { baseStyle })
